import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import {
  AfectacionesCompraConstant,
  AfectacionesVentaConstant,
  TiposDocumentoSunatConstant,
  OrigenesContabilidadConstant,
  TiposTablaComunConstant
} from 'constants/index'

import { KeyEventUtil } from 'utils'

import * as TablasComunesService from 'services/tablasComunes.service'

const TipoDocumentoFormGroup = ({
  iOrigen,
  iError,
  iTouched,
  fIsSubmitting,
  setFieldValue,
  handleChange,
  cabeceraDetalleFormikRef
}) => {
  const [documentosOptions, setDocumentosOptions] = React.useState([])

  const selectRef = React.useRef(null)

  React.useEffect(() => {
    if (iOrigen === OrigenesContabilidadConstant.COMPRAS) {
      TablasComunesService.getAsSelect(TiposTablaComunConstant.DOCUMENTOSUNAT).then(({ data }) => {
        if (data && data.length > 0) {
          setDocumentosOptions(
            data.map((x, k) => (
              <option key={k} value={x._id}>
                {x.nombre}
              </option>
            ))
          )
        }
      })
    } else {
      setDocumentosOptions(
        TiposDocumentoSunatConstant.__array.map((x, k) => (
          <option key={k} value={x.id}>
            {x.nombre}
          </option>
        ))
      )
    }
  }, [iOrigen])

  const onSelectKeyDown = React.useCallback(e => {
    if (e.keyCode === 13 || e.keyCode === 9) {
      e.preventDefault()
      KeyEventUtil.leaveOnKeyEvent('input-serieDocumento')
    }
  }, [])

  const onChange = React.useCallback(
    e => {
      handleChange(e)

      if (cabeceraDetalleFormikRef.current) {
        if (iOrigen === OrigenesContabilidadConstant.COMPRAS) {
          if (e.target.value === '02') {
            cabeceraDetalleFormikRef.current.setFieldValue(
              'tipoAfectacion',
              AfectacionesCompraConstant.RECIBO_HONORARIOS
            )
          } else {
            cabeceraDetalleFormikRef.current.setFieldValue(
              'tipoAfectacion',
              AfectacionesCompraConstant.GRAVADO_A_GRAVADO
            )
          }
        } else {
          cabeceraDetalleFormikRef.current.setFieldValue('tipoAfectacion', AfectacionesVentaConstant.GRAVADO)
        }
      }

      setFieldValue('serieDocumento', '')
      setFieldValue('codigoAduana', '')
    },
    [handleChange, setFieldValue, cabeceraDetalleFormikRef, iOrigen]
  )

  return (
    <Form.Group>
      <Form.Label text='TIPO DOC.' htmlFor='select-tipoDocumento' md={2} alignRightAt='md' />
      <Col md={10}>
        <Field name='tipoDocumento'>
          {({ field }) => (
            <Form.Select
              {...field}
              onChange={onChange}
              ref={selectRef}
              id='select-tipoDocumento'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onKeyDown={onSelectKeyDown}
            >
              <option value=''>Seleccionar</option>
              {documentosOptions}
            </Form.Select>
          )}
        </Field>
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoDocumentoFormGroup)
